import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  stockMoveUtil
} from '@/util'

const areaNameList = [
  'storage.storage_storage-move-info',
  'common.input_recipient-info'
]

const interfaceObj = {
  title: '',
  postalCode: '',
  address: '',
  phone: ''
}

function setRegisterInfo(clientData) {
  const register = clientData.client

  const registerInvoice = register.invoiceInfo
  const invoiceInfo = {
    // ...interfaceObj,
    title: areaNameList[0],
    data: register,
    registerDate: registerInvoice.storageMoveDate,
    trackingNumber: registerInvoice.trackingNumber,
    stockMoveReason: registerInvoice.storageMoveReasonId.label
  }

  const registerReceiver = register.receiverInfo
  const receiverInfo = {
    title: areaNameList[1],
    name: commonUtil.getSeparateWordsBySpace([registerReceiver.fullName]),
    postalCode: commonUtil.formatPostalCode(
      registerReceiver.postalCode,
      registerReceiver.country.value
    ),
    address:
      countryUtil.getRegionInfo(
        registerReceiver.country.value,
        commonUtil.getRegionValue(registerReceiver.region)
      ).label +
      commonUtil.getSeparateWordsBySpace([
        registerReceiver.address1,
        registerReceiver.address2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(registerReceiver.phone.phoneNumber, ''),
      registerReceiver.phone.countryCode.value
    )
  }

  return [invoiceInfo, receiverInfo]
}

function setHistoryInfo(history) {
  const invoiceInfo = {
    title: areaNameList[0],
    registerDate: history.storageMoveDate,
    trackingNumber: history.trackingNumber,
    stockMoveReason: stockMoveUtil.getStockMoveStatusName(
      history.stockMoveReasonId
    )
  }

  const receiverInfo = {
    title: areaNameList[1],
    name: commonUtil.nullEmptyFormat(history.destName, ''),
    postalCode: commonUtil.formatPostalCode(
      history.destPostalCode,
      history.destCountryId
    ),
    address:
      countryUtil.getRegionInfo(history.destCountryId, history.destRegionId)
        .label +
      commonUtil.getSeparateWordsBySpace([
        history.destAddress1,
        history.destAddress2
      ]),
    phone: countryCallingCodeUtil.formatPhoneNumber(
      commonUtil.nullEmptyFormat(history.destPhoneNumber, ''),
      history.destPhoneNumberCountryId,
      false
    )
  }

  return [invoiceInfo, receiverInfo]
}

export default { setRegisterInfo, setHistoryInfo }
